import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Check } from 'lucide-react';
import { usePage } from '../contexts/PageContext';
import SEO from '../components/SEO';
import RichText from '../components/RichText';

export default function PricingPage() {
  const { t, seo } = usePage('pricing');
  const blocks = [
    { n: '01', title: t('block_1_title', 'Platform usage'), desc: t('block_1_desc', ''), highlights: t('block_1_highlights', '').split('|').filter(Boolean), badge: 'Pay as you grow' },
    { n: '02', title: t('block_2_title', 'Setup'), desc: t('block_2_desc', ''), highlights: t('block_2_highlights', '').split('|').filter(Boolean), badge: 'One-time' },
    { n: '03', title: t('block_3_title', 'Maintenance'), desc: t('block_3_desc', ''), highlights: t('block_3_highlights', '').split('|').filter(Boolean), badge: 'Monthly' },
    { n: '04', title: t('block_4_title', 'Sales success fee'), desc: t('block_4_desc', ''), highlights: t('block_4_highlights', '').split('|').filter(Boolean), badge: 'Per sale' },
  ];
  const reasons = [t('why_1', ''), t('why_2', ''), t('why_3', ''), t('why_4', '')].filter(Boolean);
  return (
    <>
      <SEO title={seo.title} description={seo.description} keywords={seo.keywords} image={seo.og_image} />
      <section className="pt-24 pb-16 lg:pt-36 lg:pb-20">
        <div className="container-x">
          <span className="eyebrow">{t('hero_eyebrow', 'Pricing model')}</span>
          <h1 className="heading-display mt-8 text-[44px] sm:text-[72px] lg:text-[120px] max-w-5xl">{t('hero_title', 'Pay for outcomes, not for slides')}</h1>
          <p className="mt-8 text-[16px] text-[#C6C4CF] max-w-2xl"><RichText text={t('hero_description', '')} /></p>
        </div>
      </section>
      {/* Hidden until pricing model is reviewed - the 4 pricing blocks and the "Why this model wins" section are commented out */}
      {false && (
      <section className="py-16 border-t border-[#3A332A]">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
          {blocks.map((b) => (
            <div key={b.n} className="border-t border-[#3A332A] pt-8">
              <div className="flex items-center justify-between">
                <p className="text-[#F5F137] text-sm tracking-[0.28em] font-medium">{b.n}</p>
                <span className="text-[10px] uppercase tracking-[0.28em] text-[#C6C4CF] border border-[#3A332A] px-3 py-1 rounded-full">{b.badge}</span>
              </div>
              <h3 className="heading-display text-3xl lg:text-5xl mt-6">{b.title}</h3>
              <p className="mt-4 text-[#C6C4CF] leading-relaxed">{b.desc}</p>
              <ul className="mt-6 grid grid-cols-2 gap-2">
                {b.highlights.map((h, j) => (
                  <li key={j} className="flex items-center gap-2 text-sm text-[#C6C4CF]"><Check size={14} className="text-[#C6C4CF]" />{h}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
      )}
      {false && (
      <section className="py-24 lg:py-32 border-t border-[#3A332A]">
        <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <span className="eyebrow">{t('why_title', 'Why this model wins for banks')}</span>
            <h2 className="heading-display text-[36px] lg:text-[56px] mt-8">{t('why_title', 'Why this model wins for banks')}</h2>
          </div>
          <ul className="divide-y divide-[#3A332A] border-t border-[#3A332A]">
            {reasons.map((r, i) => (
              <li key={i} className="py-6 flex gap-6">
                <span className="text-[#F5F137] text-sm tracking-[0.28em] font-medium">{String(i+1).padStart(2,'0')}</span>
                <p className="text-[#FAF6EF] text-lg lg:text-xl heading-display heading-light" style={{ letterSpacing: '-0.01em' }}>{r}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>
      )}
      <section className="py-24 border-t border-[#3A332A]">
        <div className="container-x">
          <div className="border border-[#3A332A] rounded-md p-12 lg:p-20 text-center grain">
            <h2 className="heading-display text-[36px] lg:text-[64px] max-w-3xl mx-auto">{t('cta_title', 'Want a real number for your bank?')}</h2>
            <p className="mt-6 text-[#C6C4CF] max-w-xl mx-auto">{t('cta_desc', '')}</p>
            <Link to="/contact" className="btn-outline mt-8 inline-flex"><span>{t('cta_button', 'Talk to ClicksyHub')}</span><span className="arrow"><ArrowUpRight size={14} /></span></Link>
          </div>
        </div>
      </section>
    </>
  );
}
